import { NeighborhoodJob } from 'rwl-shared/dist/models/neighborhood';
import styled from '@emotion/styled';
import { ButtonBase } from 'rwl-ui';

const Container = styled.div`
    width: 224px;
    height: 100%;
    border-radius: var(--rwl-radius-sm);
    display: inline-flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    box-shadow: var(--rwl-shadow-md);
    overflow: hidden;
    cursor: pointer;
`;

const ImageContainer = styled.div`
    display: flex;
    width: 100%;
    height: 136px;
    overflow: hidden;
    border-top-right-radius: var(--rwl-radius-sm);
    border-top-left-radius: var(--rwl-radius-sm);
    background: var(--rwl-palette-gray-100);
`;

const CoverImage = styled.img`
    object-fit: cover;
    flex: 1;
    width: 100%;
    height: 100%;
`;

const BottomSection = styled.div`
    width: 100%;
    background: var(--rwl-palette-white);
    border-bottom-left-radius: var(--rwl-radius-sm);
    border-bottom-right-radius: var(--rwl-radius-sm);
    padding: var(--rwl-spacing-sm) var(--rwl-spacing-sm) var(--rwl-spacing-md)
        var(--rwl-spacing-sm);
`;

const Title = styled.p`
    margin: 0;
    width: 100%;
    font-size: 14px;
    font-weight: 500;
`;

const ButtonContainer = styled.div`
    width: 100%;
    display: flex;
    margin-top: 12px;
`;

type JobPopoverProps = {
    job: NeighborhoodJob;
    onClick?: () => void;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
};

const JobPopover = ({
    job: { title, coverImageUrl },
    onClick,
    onMouseEnter,
    onMouseLeave,
}: JobPopoverProps) => {
    return (
        <Container
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onClick={onClick}
        >
            <ImageContainer>
                <CoverImage src={coverImageUrl} loading="lazy" />
            </ImageContainer>
            <BottomSection>
                <Title>{title}</Title>
                <ButtonContainer>
                    <ButtonBase
                        className={'SeeDetailsButton'}
                        style={{
                            borderRadius: 'var(--rwl-radius-lg)',
                            backgroundColor: '#00000014',
                            color: 'var(--rwl-text-default)',
                            width: '100%',
                            height: '28px',
                            fontSize: '12px',
                            fontWeight: '500',
                            lineHeight: '20px',
                            wordWrap: 'break-word',
                        }}
                    >
                        See details
                    </ButtonBase>
                </ButtonContainer>
            </BottomSection>
        </Container>
    );
};

export default JobPopover;
